module.exports = __webpack_public_path__ + "img/products_tab_icon3.1294faa4.png";